import apiFactory from "../api";

export const getCountryAll = ({ commit }) => {
    apiFactory.getcountryallforstore().then(response => {
        commit('SET_COUNTRY', response.data);
    })
}



